export default __webpack_public_path__ + "static/expDesk-1176171f64f2958ecfe0e7a313f453c3.mp4";